import React, { Component } from "react";
import classes from "./Home.module.css";

import { Link } from "react-router-dom";
import { connect } from "react-redux";

import SmallBoxes from "../../components/MetroBoxes/SmallBoxes";
import LargeBoxes from "../../components/MetroBoxes/LargeBoxes";

import Button from "@material-ui/core/Button";
import { AppBar, IconButton, Typography, Toolbar } from "@material-ui/core";

import * as TileNames from "../../assets/Resources/HomeButtons.json";
import * as ImageURL from "../../assets/Resources/ImagesURL.json";
import * as activityFunctions from "../../store/ActivityReducer/activityFunctions";

class Home extends Component {
  componentDidMount = () => {
    console.log("componentMounted:Home");
  };

  componentDidUpdate = () => {
    console.log("componentUpdated:Home");
  };

  render() {
    const colorArray = [
      "Red",
      "Blue",
      "Brown",
      "Indigo",
      "Green",
      "Yellow",
      "Gray",
    ];
    const Tiles = TileNames.Tiles.map((Tile) => {
      let TileSize = [];
      if (Tile.TileCode.charAt(1) === "L") {
        TileSize.push(classes.LargeTile);
      } else {
        TileSize.push(classes.SmallTile);
      }

      const color = colorArray[Math.floor(Math.random() * colorArray.length)];
      return (
        <Link to="/activity" key={Tile.name}>
          <Button
            className={TileSize}
            onClick={() => this.props.onClickTile(Tile.name)}
            style={{ backgroundColor: color }}
            startIcon={<img src={Tile.ImageURI} alt={Tile.name}></img>}
          >
            {Tile.name}
          </Button>
        </Link>
      );
    });

    const BoxA = (
      <SmallBoxes Heading="ORGANIZATION" Tiles={Tiles.slice(0, 4)} />
    );

    const BoxB = (
      <LargeBoxes Heading="BUSINESS TRANSACTIONS" Tiles={Tiles.slice(4, 13)} />
    );

    const BoxC = (
      <SmallBoxes Heading="ASSET SECTION" Tiles={Tiles.slice(13, 17)} />
    );

    const BoxD = <SmallBoxes Heading="ASSET SECTION" Tiles={Tiles.slice(17)} />;

    const Header = (
      <div className={classes.Heading}>
        <AppBar
          style={{ background: "transparent", boxShadow: "none" }}
          className={classes.AppBar}
        >
          <Toolbar>
            <IconButton edge="start" size="medium">
              <img src={ImageURL.Settings.URL} alt={ImageURL.Settings.alt} />
            </IconButton>
            <Typography variant="h3">KRM Asset Management System</Typography>
            <IconButton
              edge="end"
              size="medium"
              style={{ position: "absolute", right: "50px" }}
            >
              <img src={ImageURL.User.URL} alt={ImageURL.User.alt} />
            </IconButton>
          </Toolbar>
        </AppBar>
      </div>
    );

    return (
      <div className={classes.Home}>
        {Header}
        <div style={{ display: "flex" }}>
          {BoxA}
          {BoxB}
          {BoxC}
          {BoxD}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onClickTile: (tileName) => dispatch(activityFunctions.clickTile(tileName)),
  };
};

export default connect(null, mapDispatchToProps)(Home);
